module.exports = __webpack_public_path__ + "static/media/private_active_1.d138c8c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bin/private_active_1.png
// module id = 3476
// module chunks = 0